import { render } from "./AppFilters.vue?vue&type=template&id=8b3ca2d6&scoped=true"
import script from "./AppFilters.vue?vue&type=script&lang=js"
export * from "./AppFilters.vue?vue&type=script&lang=js"

import "./AppFilters.vue?vue&type=style&index=0&id=8b3ca2d6&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3ca2d6"]])

export default __exports__